import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import 'materialize-css/dist/css/materialize.min.css';
import jwt from 'jsonwebtoken';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import M from "materialize-css";
import '../style/Navigation.css';
import * as CONS from '../CONS'

import logo_soymas from '../img/1x/logo_soymas.png'

const MySwal = withReactContent(Swal);

class Navigation extends Component {

    state = {
        id_user: 0,
        level: 0,
        id_rol: 0,
        rol_name: "No logueado",
        fullname: "No logueado",
        point: 0
    };

    async fetchUserAndRol() {
        try {
            const token = localStorage.getItem("jwtToken");
            if (!token) {
                return;
            }
            const id_user = jwt.decode(token).id_user;

            const response = await fetch(localStorage.getItem("api") + '/user/rol/' + id_user, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                })
            });
            const data = await response.json();
            this.setState({
                id_user: id_user,
                id_rol: data.id_rol,
                point: data.point,
                level: data.level,
                rol_name: data.name,
                fullname: data.fullname
            });
        } catch (err) {
            console.log(err.toString())
            return;
        }
    }

    async updatePasswordById(password_cur, password) {
        const token = localStorage.getItem("jwtToken");
        const { id_user } = jwt.decode(token);

        const response = await fetch(localStorage.getItem("api") + '/user/password/' + id_user, {
            method: 'PUT',
            headers: new Headers({
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }),
            body: JSON.stringify(
                {
                    id_user,
                    password_cur,
                    password
                }
            )
        })
            .catch(err => {
                MySwal.fire({
                    title: CONS.err_server,
                    type: 'error',
                    timer: 3000
                })
                console.log(err);
                console.log(CONS.err_server);
                return;
            })
        const data = await response.json();
        if (data.errors)
            MySwal.fire({
                title: data.status,
                type: 'error',
                timer: 3000
            })
        else
            MySwal.fire({
                title: data.status,
                type: 'success',
                timer: 3000
            })
    }

    changePass() {
        Swal.fire({
            title: 'Cambio de contraseña',
            html:
                "<div class='row'>" +
                "<p class='col s6'>Contraseña actual</p>" +
                "<input type='password' id='swal_password_cur' name='password_cur' class='col s6' value='' />" +
                "</div><div class='row'>" +
                "<p class='col s6'>Nueva Contraseña</p>" +
                "<input type='password' id='swal_password' name='password' class='col s6' value='' />" +
                "</div><div class='row'>" +
                "<p class='col s6'>Repita Nueva Contraseña</p>" +
                "<input type='password' id='swal_password2' name='password2' class='col s6' value='' />" +
                "</div>",
            customClass: {
                container: 'swal-change-pass'
            },
            showCancelButton: true,
            confirmButtonText: 'Enviar solicitud',
            cancelButtonText: "Cancelar",
            showLoaderOnConfirm: true,
            inputValidator: (value) => {
                console.log(value)
            },
            preConfirm: (value) => {
                const password_cur = document.getElementById('swal_password_cur').value;
                const password = document.getElementById('swal_password').value;
                const password2 = document.getElementById('swal_password2').value;

                console.log(password_cur)
                console.log(password)
                console.log(password2)
                if (password_cur.length <= 0
                    || password.length <= 0
                    || password2.length <= 0)
                    Swal.showValidationMessage(
                        `Hay campos vacíos`
                    )
                else if (password !== password2) {
                    Swal.showValidationMessage(
                        `Las nuevas contraseñas no coinciden`
                    )
                }
                else
                    return {
                        "password_cur": password_cur,
                        "password": password,
                        "password2": password2,
                    }
            }
        }).then((result) => {
            if (result.dismiss) {
                return;
            }
            this.updatePasswordById(result.value.password_cur, result.value.password)
        });
    }

    refreshNavigation() {
        this.forceUpdate()
    }

    componentDidMount() {
        if (localStorage.getItem("jwtToken")) {
            this.fetchUserAndRol();

            var elems = document.querySelectorAll('.sidenav');
            var optionsSideNav = {};
            M.Sidenav.init(elems, optionsSideNav);

            elems = document.querySelectorAll('.dropdown-trigger');
            var optionsDropDown = { coverTrigger: false };
            M.Dropdown.init(elems, optionsDropDown);

            elems = document.querySelectorAll('.collapsible');
            var optionsCollapsible = {};
            M.Collapsible.init(elems, optionsCollapsible);

            elems = document.querySelectorAll('.tooltipped');
            var optionsTooltip = {}
            M.Tooltip.init(elems, optionsTooltip);

        } else {
            console.log("No existe usuario logueado")
        }
    }

    render() {
        if (localStorage.getItem("jwtToken")) {
            const token = jwt.decode(localStorage.getItem("jwtToken")).id_user;
            const { fullname, point, level } = this.state;
            if (token.level !== level) {
                // this.refreshNavigation();
            }

            /*Inicio*/
            // var linkHome = <li><NavLink to="/">Home</NavLink></li>;
            /*Los jefes entregan puntos, máximo dos entregas por año para cada empleado*/
            // var linkDarPunto = <li><NavLink to="/dar_puntos">Dar puntos</NavLink></li>;
            /*Los empleados reclaman regalos*/
            var linkRedimir = <li><NavLink to="/redimir_puntos">Redimir puntos</NavLink></li>;
            /*Los gestores administran los regalos*/
            var linkRegalo = <li><NavLink to="/regalos">Beneficios</NavLink></li>
            /* Los jefes aceptan/rechazan solicitudes de regalos */
            var linkSolicitud = <li><NavLink to="/solicitud">Solicitudes</NavLink></li>;
            /*Los gestores administran los usuarios*/
            var linkUsuario = <li><NavLink to="/crear_usuario">Usuarios</NavLink></li>;

            var userLink;

            var sidenav;

            if (level >= 15) {
                userLink = (
                    <React.Fragment>
                        {/* {linkDarPunto} */}
                        {linkRedimir}
                        {linkRegalo}
                        {linkSolicitud}
                        {linkUsuario}
                    </React.Fragment>
                );
            } else if (level >= 12) {
                userLink = (
                    <React.Fragment>
                        {linkRedimir}
                        {linkSolicitud}
                    </React.Fragment>
                );
            } else if (level >= 10) {//Empleado
                userLink = (
                    <React.Fragment>
                        {linkRedimir}
                        {linkSolicitud}
                    </React.Fragment>
                );
            }

            sidenav =
                <div id="Navigation">
                    <nav>
                        <div className="nav-wrapper">
                            <a href="#!" data-target="nav-mobile" className="sidenav-trigger ">
                                <i className="material-icons">menu</i>
                            </a>
                            <a href="/" className="brand-logo right"><img src={logo_soymas} alt="logo Soy+"></img></a>
                            <ul className="right hide-on-med-and-down">
                                {userLink}
                                <li>
                                    <a href="#!" className="dropdown-trigger" data-target="dropdown1">
                                        <span className="rol">{fullname} <b>({point})</b></span><i className="material-icons right">arrow_drop_down</i>
                                    </a>
                                    <ul id='dropdown1' className='dropdown-content'>
                                        <li><a href="#!" onClick={() => this.changePass()}>Cambiar Contraseña</a></li>
                                        <li className="divider" ></li>
                                        <li><NavLink to="/logout">Cerrar Sesión</NavLink></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </nav>

                    <ul id="nav-mobile" className="sidenav">
                        {userLink}
                        <li className="no-padding">
                            <ul className="collapsible collapsible-accordion">
                                <li>
                                    <a href="#!" className="collapsible-header">
                                        <span className="rol">{fullname} <b>({point})</b></span><i className="material-icons right">arrow_drop_down</i>
                                    </a>
                                    <div className="collapsible-body">
                                        <ul>
                                            <li><a href="#!" onClick={() => this.changePass()}>Cambiar Contraseña</a></li>
                                            <li className="divider" ></li>
                                            <li><NavLink to="/logout">Cerrar Sesión</NavLink></li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </li>
                    </ul>


                </div >;
        } else {
            console.log("Sin usuario logueado")
        }

        return (
            <React.Fragment>
                {sidenav}
            </React.Fragment>
        );
    }

}

export default Navigation